import { render, staticRenderFns } from "./IconTeaser.vue?vue&type=template&id=fd2b3bb2&scoped=true&"
import script from "./IconTeaser.vue?vue&type=script&lang=js&"
export * from "./IconTeaser.vue?vue&type=script&lang=js&"
import style0 from "./IconTeaser.vue?vue&type=style&index=0&id=fd2b3bb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2b3bb2",
  null
  
)

export default component.exports